import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { withStyles, MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import CheckIcon from '@material-ui/icons/Check';
import sectionStyles from './index.module.css';

const StyledTabs = withStyles({
  indicator: {
    display: 'flex',
    height: 4,
    justifyContent: 'center',
    backgroundColor: 'transparent',
    '& > div': {
      maxWidth: 80,
      width: '100%',
      backgroundColor: '#4e6155',
    },
  },
})(props => <Tabs {...props} TabIndicatorProps={{ children: <div /> }} />);

const StyledTab = withStyles(() => ({
  root: {
    fontSize: 16,
    fontFamily: 'Oswald, sans-serif',
    fontWeight: 400,
    minWidth: 120,
    textTransform: 'none',
    letterSpacing: '0.04em',
  },
}))(props => <Tab disableRipple {...props} />);

const orangeTheme = createMuiTheme({ palette: { primary: { main: '#000000' } } });

const M3_BASIC_PLAN_PRICE = 70;
const M3_PLAN_PRICE_INCREMENT = 20;
const TRANSACTION_VOLUME_LARGE_PRICE_INCREMENT = 50;

const INCLUDED = [
  'Membership management',
  'Attendance tracking',
  'Face ID check-in',
  'E-mail messaging',
  'Reports',
  'Staff accounts',
  'AI assistance',
  'Automated payments (M3 plan)',
];

class PricingDetailsSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeCarouselItemIndex: 0,
      transactionVolumeTabIndex: 0,
    };
  }

  handleTransactionVolumeChange = (event, newValue) => {
    this.setState({ transactionVolumeTabIndex: newValue });
  };

  calculatePlanPrice = () => {
    const { activeCarouselItemIndex, transactionVolumeTabIndex } = this.state;
    let price = M3_BASIC_PLAN_PRICE;
    price += activeCarouselItemIndex === 1 ? M3_PLAN_PRICE_INCREMENT : 0;
    price += transactionVolumeTabIndex === 1 ? TRANSACTION_VOLUME_LARGE_PRICE_INCREMENT : 0;
    return price;
  };

  render() {
    const { activeCarouselItemIndex, transactionVolumeTabIndex } = this.state;
    const isBasic = activeCarouselItemIndex === 0;

    return (
      <section className={`${sectionStyles.pageSection} section`}>
        <div className={sectionStyles.pricingBlock}>
          <div className={`${sectionStyles.blockInner} contentContainer`}>
            <h2 className={sectionStyles.blockTitle}>Monthly software</h2>
            <p className={sectionStyles.blockSubtitle}>Pick your plan and member range. Prices in CAD.</p>

            <div className={sectionStyles.planToggle} role="group" aria-label="Plan type">
              <button
                type="button"
                className={`${sectionStyles.planBtn} ${isBasic ? sectionStyles.planBtnActive : ''}`}
                onClick={() => this.setState({ activeCarouselItemIndex: 0 })}
              >
                M3 Basic
              </button>
              <button
                type="button"
                className={`${sectionStyles.planBtn} ${!isBasic ? sectionStyles.planBtnActive : ''}`}
                onClick={() => this.setState({ activeCarouselItemIndex: 1 })}
              >
                M3
              </button>
            </div>

            <p className={sectionStyles.memberLabel}>Active members</p>
            <StyledTabs
              value={transactionVolumeTabIndex}
              onChange={this.handleTransactionVolumeChange}
              centered
              className={sectionStyles.memberTabs}
            >
              <StyledTab label="1 – 100" />
              <StyledTab label="Over 100" />
            </StyledTabs>

            <div className={sectionStyles.priceWrap}>
              <span className={sectionStyles.currency}>$</span>
              <span className={sectionStyles.priceAmount}>{this.calculatePlanPrice()}</span>
              <span className={sectionStyles.pricePeriod}>/ month</span>
            </div>

            <MuiThemeProvider theme={orangeTheme}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                className={sectionStyles.getStarted}
                component={GatsbyLink}
                to="/contact/"
              >
                Get started
              </Button>
            </MuiThemeProvider>
          </div>
        </div>

        <div className={sectionStyles.includedSection}>
          <div className={`${sectionStyles.blockInner} contentContainer`}>
            <h2 className={sectionStyles.includedHeading}>What&apos;s included</h2>
            <p className={sectionStyles.includedSub}>
              Core platform features with every {isBasic ? 'M3 Basic' : 'M3'} account.
            </p>
            <ul className={sectionStyles.featureGrid}>
              {INCLUDED.map((label) => {
                const isPayments = label.includes('Automated');
                const disabled = isBasic && isPayments;
                return (
                  <li
                    key={label}
                    className={`${sectionStyles.featureItem} ${disabled ? sectionStyles.featureItemMuted : ''}`}
                  >
                    <span className={sectionStyles.featureCheck} aria-hidden>
                      <CheckIcon style={{ fontSize: 18 }} />
                    </span>
                    <div className={sectionStyles.featureText}>
                      <span>{label}</span>
                      {disabled && (
                        <span className={sectionStyles.featureNote}>M3 plan only</span>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </section>
    );
  }
}

export default PricingDetailsSection;
